// What this device can do about notifications, so the prompt shows the right
// screen: turn on now, add to the Home Screen first (iPhone and iPad), update
// iOS, unblock in settings, or nothing. Wrong guesses are harmless: turning on
// still explains any failure.

// Opened from the Home Screen as an app, rather than in a browser tab
export const isStandalone = () =>
  window.navigator.standalone === true || !!window.matchMedia?.('(display-mode: standalone)').matches;

const currentEnv = () => ({
  ua: navigator.userAgent || '',
  maxTouchPoints: navigator.maxTouchPoints || 0,
  standalone: isStandalone(),
  hasPush: 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window,
  permission: 'Notification' in window ? Notification.permission : 'default',
});

export function pushPlatform(env = currentEnv()) {
  const { ua, maxTouchPoints, standalone, hasPush, permission } = env;
  // iPads report themselves as a Mac; a touch screen gives them away
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1);
  const browser = /CriOS/.test(ua) ? 'chrome' : /FxiOS|Firefox/.test(ua) ? 'firefox'
    : /Chrome|Edg/.test(ua) ? 'chrome' : /Safari/.test(ua) ? 'safari' : 'other';
  if (permission === 'denied') return { kind: 'blocked', browser, ios };
  if (ios) {
    const m = ua.match(/OS (\d+)_(\d+)/) || ua.match(/Version\/(\d+)\.(\d+)/);
    const version = m ? Number(m[1]) + Number(m[2]) / 100 : 99;
    if (version < 16.04) return { kind: 'ios-old', browser, ios };
    if (!standalone) return { kind: 'ios-install', browser, ios };
  }
  return { kind: hasPush ? 'ready' : 'unsupported', browser, ios };
}
